<app-dynamic-table
	[elements]="data"
	[tableRows]="tableRows"
	[module]="type + '_history'"
	[haveLink]="false"
></app-dynamic-table>
